import { render } from "./StockPanel.vue?vue&type=template&id=c23cc030"
import script from "./StockPanel.vue?vue&type=script&lang=js"
export * from "./StockPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__